import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api from "@/lib/api";
import { logger } from "@/lib/logger";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);   // null=loading, false=unauth, object=auth
  const [driverProfile, setDriverProfile] = useState(null);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setDriverProfile(data.driver_profile || null);
    } catch {
      setUser(false);
      setDriverProfile(null);
    }
  }, []);

  useEffect(() => { fetchMe(); }, [fetchMe]);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    await fetchMe();
    return data.user;
  }, [fetchMe]);

  const register = useCallback(async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    await fetchMe();
    return data.user;
  }, [fetchMe]);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (err) { logger.warn("[auth] logout error", err); }
    setUser(false);
    setDriverProfile(null);
  }, []);

  const value = useMemo(
    () => ({ user, driverProfile, login, register, logout, refresh: fetchMe }),
    [user, driverProfile, login, register, logout, fetchMe]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
